import { memo, useState, useEffect, useRef } from 'react';
import style from './SplashScreen.module.css';
import SplashLogo from '../../images/common/logo_landing_new.svg';
import SplashBotLogo from '../../images/common/logo_splash_bottom.svg';
import axiosApi from '../../api/daonAxios';
import CODE from '../../constants/code';

const SplashScreen = memo(function SplashScreen({ onComplete }) {

  //const [todayWord, setTodayWord] = useState("");

  // [중요] 중복 실행 및 언마운트 후 실행 방지
  const isFinishedRef = useRef(false);
  const timerRef = useRef(null);

  // ✅ 종료 처리 함수 (안전장치 포함)
  const handleCompleteSafe = () => {
    if (isFinishedRef.current) return;

    // 이미 완료 상태로 변경
    isFinishedRef.current = true;

    // 타이머 클리어
    if (timerRef.current) clearTimeout(timerRef.current);

    if (onComplete) onComplete();
  };

  useEffect(() => {
    // 1. 세션 스토리지 처리
    try {
      sessionStorage.setItem('splashShown', 'true');
    } catch (e) {
      console.log("세션 스토리지 저장 불가");
    }

    // 2. 데이터 페칭 / 스크래핑 주석처리 (2025.12.30)
    // const getTodayWord = async () => {
    //   try {
    //     const res = await axiosApi.post("/guide/missa/todayMissa");
    //     if (res.data.resultCode === CODE.RCV_SUCCESS) {
    //       setTodayWord(res.data.result.todayMissa);
    //     }
    //   } catch (err) {
    //     setTodayWord("고생하는 너희는 모두 나에게 오너라.");
    //   }
    // };
    // getTodayWord();

    
    // 3. [핵심] 강제 종료 타이머 (CSS 애니메이션 시간보다 넉넉하게, 예: 4초)
    // 백그라운드에서도 타이머는 (느리지만) 결국 돕니다.
    timerRef.current = setTimeout(() => {
      console.log("⏰ 스플래시 강제 종료 (타임아웃)");
      handleCompleteSafe();
    }, 4000); // 애니메이션 시간 + 0.5~1초 추천


    // 4. [핵심] 화면 복귀 감지 리스너
    // 애니메이션이 씹혔어도, 유저가 앱을 다시 켰을 때 강제로 닫아버림
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // 앱으로 돌아왔는데 아직 스플래시가 안 끝났다? 바로 종료 시도
        // (사용자가 1초만에 나갔다 들어오는 경우를 대비해 약간의 딜레이를 줄 수도 있음)
        setTimeout(() => {
          if (!isFinishedRef.current) {
            console.log("👁️ 앱 복귀 감지: 스플래시 종료");
            handleCompleteSafe();
          }
        }, 500);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const handleAnimationEnd = (e) => {
    // containerDismiss 애니메이션이 끝나면 종료
    if (e.animationName && e.animationName.includes('containerDismiss')) {
      handleCompleteSafe();
    }
  };

  return (
    <div
      className={style['splash-bg']}
      onAnimationEnd={handleAnimationEnd}
    >
      <div className={style['splash-center']}>
        <div className={style['img-box']}>
          <img src={SplashLogo} alt="CMC 로고" />
        </div>
      </div>

      <div className={style['splash-bottom']}>
        <strong>CMC 케어플러스</strong>
        <p>
          <img src={SplashBotLogo} alt="CMC 로고" />
        </p>
      </div>
    </div>
  );
});

export default SplashScreen;